import { QueryError } from "@/components/ui/query-error/query-error";
import { Skeleton } from "@/components/ui/skeleton/skeleton";
import { cn } from "@/lib/utils";
import { vEXDSSnagAndNote } from "@/odata/appu4dm/AppU4DMModel";
import { useNote } from "@/queries/note/use-note";
import { useTranslation } from "react-i18next";

export interface NoteProps {
  onClick?: () => void;
}

export function Note({ onClick }: NoteProps) {
  const { t } = useTranslation();
  const { notes, isPending, error, refetch } = useNote();
  const note = notes?.[0];
  const isClickable = !!onClick && !isPending;

  if (error) {
    return (
      <QueryError
        resource={t("notes.note")}
        errors={[error]}
        retries={[refetch]}
      />
    );
  }

  return (
    <div
      onClick={onClick}
      className={cn(
        "h-full bg-card border rounded-sm p-2 overflow-hidden",
        isClickable && "cursor-pointer",
        isPending ? "overflow-hidden" : "overflow-auto"
      )}
    >
      {isPending &&
        [...Array(24)].map((_, i) => (
          <Skeleton className="h-[16px] m-2" key={i} />
        ))}
      {!isPending && <NoteMessage note={note} />}
    </div>
  );
}

function NoteMessage({ note }: { note?: vEXDSSnagAndNote }) {
  if (!note?.Message) return null;

  return (
    <p
      className="whitespace-pre-wrap break-words "
      dangerouslySetInnerHTML={{ __html: note.Message }}
    />
  );
}
